<template>
  <v-menu offset-y>
    <template v-slot:activator="{ props }">
      <v-btn
        v-bind="props"
        :variant="variant"
        :size="size"
        :color="color"
        :icon="icon"
        class="language-switcher"
      >
        <v-icon v-if="icon">mdi-translate</v-icon>
        <span v-else class="text-uppercase font-weight-bold">
          {{ currentLanguageCode }}
        </span>
      </v-btn>
    </template>

    <v-list class="language-menu">
      <v-list-item
        v-for="lang in languages"
        :key="lang.code"
        :class="{ 'active-language': lang.code === currentLocale }"
        @click="changeLanguage(lang.code)"
      >
  <template v-slot:prepend>
          <v-avatar size="small" class="me-3">
            <v-img :src="lang.flag" :alt="lang.name" />
          </v-avatar>
        </template>
        
        <v-list-item-title>{{ lang.name }}</v-list-item-title>
        
  <template v-slot:append>
          <v-icon
            v-if="lang.code === currentLocale"
            color="primary"
            size="small"
          >
            mdi-check
          </v-icon>
        </template>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'

// Props
const props = defineProps({
  variant: {
    type: String,
    default: 'outlined'
  },
  size: {
    type: String,
    default: 'small'
  },
  color: {
    type: String,
    default: 'primary'
  },
  icon: {
    type: Boolean,
    default: false
  }
})

// Composables
const { locale } = useI18n()
const router = useRouter()
const route = useRoute()

// Computed
const currentLocale = computed(() => locale.value)

const languages = computed(() => [
  {
    code: 'kz',
    name: 'Қазақша',
    flag: '/images/flags/kz.svg'
  },
  {
    code: 'ru',
    name: 'Русский',
    flag: '/images/flags/ru.svg'
  },
  {
    code: 'en',
    name: 'English',
    flag: '/images/flags/en.svg'
  }
])

const currentLanguageCode = computed(() => {
  return languages.value.find(lang => lang.code === currentLocale.value)?.code.toUpperCase() || 'KZ'
})

// Methods
const changeLanguage = (langCode) => {
  if (langCode !== locale.value) {
    // Update locale reactively
    locale.value = langCode
    localStorage.setItem('korkem-auto-locale', langCode)
    
    // Console log removed
    // Console log removed
    
    // Vue i18n is reactive, no need to reload the page
    // The interface will update automatically
  }
}
</script>

<style scoped>
.language-switcher {
  border-radius: 8px;
  min-width: 48px;
}

.language-menu {
  border-radius: 12px;
  overflow: hidden;
}

.active-language {
  background: rgba(255, 193, 7, 0.1);
  color: #FFC107;
}

.v-list-item {
  transition: all 0.3s ease;
}

.v-list-item:hover {
  background: rgba(255, 193, 7, 0.05);
}
</style>